import React, { useState, Fragment, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';

const MuiMenuItem = React.forwardRef((props, ref) => {
  return <MenuItem ref={ref} {...props} />;
});

const ListMenuItem = ({
  label,
  icon,
  onClick,
  className,
  items = [],
  styleIcon,
  disabled,
  id,
  collapseOpen,
  paddingLeft = 0,
  divider,
  classNameIcon,
  classNameText,
  showNotification = true,
  badgeContent = 0
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e) => {
    if (items.length > 0) {
      setOpen(!open);
    } else {
      if (onClick) {
        onClick(e);
      }
    }
  };

  useEffect(() => {
    setOpen(collapseOpen);
  }, [collapseOpen]);

  return (
    <Fragment key={`key-${id}`}>
      {divider && <Divider />}
      <ListItem
        key={id}
        button
        onClick={handleClick}
        className={`list-menu-item ${className}`}
        disabled={disabled}
        style={{ paddingLeft: 16 + paddingLeft * 16 }}
      >
        {icon && (
          <ListItemIcon>
            <FontAwesomeIcon icon={icon} className={classNameIcon} />
          </ListItemIcon>
        )}
        <ListItemText className={classNameText} disableTypography={true} primary={label} />

        {showNotification && badgeContent ? (
          <Badge badgeContent={badgeContent}  className='badge-notification'>
            <NotificationsIcon />
          </Badge>
        ) : (
          <></>
        )}
        {items.length > 0 && (
          <ListItemSecondaryAction>
            {open ? <FontAwesomeIcon icon='chevron-up' /> : <FontAwesomeIcon icon='chevron-down' />}
          </ListItemSecondaryAction>
        )}
      </ListItem>
      {items.length > 0 && (
        <Collapse in={open} timeout='auto' unmountOnExit disabled={disabled}>
          <List
            component='div'
            className='list-menu p-0'
            style={{ backgroundColor: 'rgb(207, 211, 220, 0.2)' }}
          >
            {items.map((x, index) => (
              <ListMenuItem
                key={`key-${id}-${index}`}
                id={`${id}-${index}`}
                icon={x.icon}
                label={x.label}
                onClick={x.onClick}
                items={x.items}
                className={x.className}
                classNameIcon={x.classNameIcon}
                classNameText={x.classNameText}
                divider={x.divider}
                collapseOpen={x.collapseOpen}
                paddingLeft={paddingLeft + 1}
                showNotification={x.showNotification}
                badgeContent={x.badgeContent}
              />
            ))}
          </List>
        </Collapse>
      )}
    </Fragment>
  );
};

export default ListMenuItem;
